var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeaknesses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5151",
    "data-name": "Group 5151",
    transform: "translate(-1007 -644)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_232",
    "data-name": "Ellipse 232",
    transform: "translate(1013 650)",
    fill: "#f9b33a",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 47,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_2",
    "data-name": 2,
    transform: "translate(1032.621 669.621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15042",
    "data-name": "Path 15042",
    d: "M157.869,21.22l4.078-2.739A20.482,20.482,0,0,1,173.369,15h12.039m-9.349,24.024,1.578,6.8a6.084,6.084,0,0,1-4.685,7.332h0l-3.588-7.574a14.165,14.165,0,0,0-4.829-5.645L157.869,35.4",
    transform: "translate(-142.433 -15)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15043",
    "data-name": "Path 15043",
    d: "M15.215,15.114H26.686a2.823,2.823,0,0,1,2.822,2.822v18.27a2.823,2.823,0,0,1-2.822,2.822H15.215ZM38.832,56.95,36.76,59.022M50.194,56.95l2.072,2.072M44.513,60.47V63.4M23.364,32.977h0m20.309,5.842H60.506a2.963,2.963,0,0,0,2.963-2.963h0a2.963,2.963,0,0,0-2.963-2.963",
    transform: "translate(-15.215 -15.102)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15044",
    "data-name": "Path 15044",
    d: "M458.243,139.394H457.23a3,3,0,0,0,3-3h0a3,3,0,0,0-3-3",
    transform: "translate(-412.984 -121.558)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15045",
    "data-name": "Path 15045",
    d: "M447.344,80.249H446.23a3,3,0,0,0,3-3h0a3,3,0,0,0-3-3",
    transform: "translate(-403.098 -68.257)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15046",
    "data-name": "Path 15046",
    d: "M431.851,21.1h-1.62a3,3,0,0,0,3-3h0a3,3,0,0,0-3-3",
    transform: "translate(-388.718 -15.102)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeaknesses);
export default __webpack_public_path__ + "static/media/Weaknesses.d0bac47dd75fc4e3cbc70eb283366bc1.svg";
export { ForwardRef as ReactComponent };